import { authorizedApi } from './index';

export const packsApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    preparePackTransaction: builder.mutation({
      query: ({ baseToken, baseTokenAmount }) => ({
        url: '/packs/prepareTransaction',
        method: 'POST',
        body: { baseToken, baseTokenAmount },
      }),
    }),
    broadcastPackTransaction: builder.mutation({
      query: ({
        serializedTransaction,
        baseToken,
        baseTokenAmount,
        packType,
      }) => ({
        url: '/packs/broadcastTransaction',
        method: 'POST',
        body: { serializedTransaction, baseToken, baseTokenAmount, packType },
      }),
    }),
  }),
});

export const {
  usePreparePackTransactionMutation,
  useBroadcastPackTransactionMutation,
} = packsApi;
